/* Spotminders LP — dynamic offer rules + sticky CTA visibility.
   Plain JS, no Liquid. All configuration arrives via data- attributes:

     [data-sm-offer]   data-tz data-cutoff data-omin data-omax
                       data-stable data-rolld data-endstr
     [data-sm-sticky]  data-gate data-hide-over-offer

   Loaded with `defer`, so it runs after the document is parsed. */

(function () {
  'use strict';
  if (window.__smRules) return;
  window.__smRules = true;

  var MONTHS_FMT = { month: 'long' };

  function num(v, fallback) { var n = parseFloat(v); return isNaN(n) ? fallback : n; }
  function setAll(key, value) {
    var n = document.querySelectorAll('[data-sm="' + key + '"]');
    for (var i = 0; i < n.length; i++) n[i].textContent = value;
  }

  /* =============================== offer rules =============================== */
  function initOffer() {
    var root = document.querySelector('[data-sm-offer]');
    if (!root) return;

    var TZ     = root.getAttribute('data-tz') || 'America/New_York';
    var CUTOFF = num(root.getAttribute('data-cutoff'), 14);
    var OMIN   = num(root.getAttribute('data-omin'), 2543);
    var OMAX   = num(root.getAttribute('data-omax'), 3864);
    var STABLE = root.getAttribute('data-stable') === 'true';
    var ROLLD  = num(root.getAttribute('data-rolld'), 6);
    var ENDSTR = root.getAttribute('data-endstr') || '';

    function nowTZ() {
      var p = new Intl.DateTimeFormat('en-US', {
        timeZone: TZ, year: 'numeric', month: 'numeric', day: 'numeric',
        hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: false
      }).formatToParts(new Date());
      function n(t) { for (var i = 0; i < p.length; i++) if (p[i].type === t) return +p[i].value; return 0; }
      return { y: n('year'), m: n('month'), d: n('day'),
               H: n('hour') % 24, M: n('minute'), S: n('second') };
    }
    function fmt(y, m, d) {
      return new Date(Date.UTC(y, m - 1, d))
        .toLocaleDateString('en-US', { month: 'long', day: 'numeric', timeZone: 'UTC' });
    }

    /* 1 + 2 — current month, random order count */
    function orders() {
      if (STABLE) { try { var c = sessionStorage.getItem('sm_orders'); if (c) return +c; } catch (e) {} }
      var n = Math.floor(Math.random() * (OMAX - OMIN + 1)) + OMIN;
      if (STABLE) { try { sessionStorage.setItem('sm_orders', n); } catch (e) {} }
      return n;
    }
    function scarcity() {
      var opts = { timeZone: TZ }; opts.month = MONTHS_FMT.month;
      setAll('month', new Intl.DateTimeFormat('en-US', opts).format(new Date()));
      setAll('orders', orders().toLocaleString('en-US'));
    }

    /* 3 — ships today / tomorrow */
    function shipping() {
      var t = nowTZ(), after = t.H >= CUTOFF;
      var d = new Date(Date.UTC(t.y, t.m - 1, t.d));
      if (after) d.setUTCDate(d.getUTCDate() + 1);
      setAll('ship-chip', (after ? 'Ships tomorrow' : 'Ships today') + ', ' +
        fmt(d.getUTCFullYear(), d.getUTCMonth() + 1, d.getUTCDate()));
    }

    /* 4 — countdown to the next cutoff */
    var lastAfter = null;
    function cutoffTick() {
      var t = nowTZ();
      var left = CUTOFF * 3600 - (t.H * 3600 + t.M * 60 + t.S);
      if (left <= 0) left += 86400;
      setAll('ship-countdown', 'within ' + Math.floor(left / 3600) + 'hr ' +
        Math.floor((left % 3600) / 60) + 'mins ' + (left % 60) + ' sec');
      var after = t.H >= CUTOFF;
      if (lastAfter !== null && after !== lastAfter) shipping();
      lastAfter = after;
    }

    /* promo countdown — fixed end date, else a rolling window */
    var target = null;
    if (ENDSTR) { var p = Date.parse(ENDSTR.replace(' ', 'T')); if (!isNaN(p)) target = p; }
    if (!target || target < Date.now()) {
      var span = ROLLD * 86400000;
      target = Math.ceil(Date.now() / span) * span;
    }
    function promoTick() {
      var left = Math.max(0, target - Date.now());
      var s = Math.floor(left / 1000);
      function box(k, v) {
        var n = document.querySelectorAll('[data-sm-cd="' + k + '"]');
        for (var i = 0; i < n.length; i++) n[i].textContent = v;
      }
      box('d', Math.floor(s / 86400));
      box('h', Math.floor(s % 86400 / 3600));
      box('m', Math.floor(s % 3600 / 60));
      box('s', s % 60);
    }

    scarcity();
    shipping();
    cutoffTick();
    promoTick();
    setInterval(function () { cutoffTick(); promoTick(); }, 1000);
  }

  /* ============================= sticky visibility ============================ */
  function initSticky() {
    var bar = document.querySelector('[data-sm-sticky]');
    if (!bar) return;

    var gateIndex     = num(bar.getAttribute('data-gate'), 3);
    var hideOverOffer = bar.getAttribute('data-hide-over-offer') === 'true';
    var refs = {};

    function lookup() {
      refs.gate  = document.querySelectorAll('.sm-pt')[gateIndex - 1] || null;
      refs.offer = document.querySelector('[data-sm-offer]');
    }
    function inView(el) {
      if (!el) return false;
      var r = el.getBoundingClientRect();
      return r.top < (window.innerHeight || 0) && r.bottom > 0;
    }
    function reached(el) { return el ? el.getBoundingClientRect().top <= 0 : true; }
    function update() {
      if (!refs.gate || !refs.offer) lookup();
      bar.classList.toggle('is-off',
        !reached(refs.gate) || (hideOverOffer && inView(refs.offer)));
    }

    var queued = false;
    function onScroll() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; update(); });
    }

    lookup();
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  }

  function start() { initOffer(); initSticky(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();